import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParqueService {

  getParque(): Observable<any[]> {
    const items = [
      {
        stars: '4.8',
        name: 'Parque Chico Mendes',
        horarioAberto: '05:00 - 22:00',
        possuiEstacionamento: false,
        endereco: 'Rua das Amoras, 126 - Jardim das flores',
        image: '/assets/images/parques/entrada-estacionamento.jfif',
        distancia: 5,
        latitude: -23.0227,
        longitude: -43.4719,
      },
      {
        stars: '4.8',
        name: 'Parque exemplo 2',
        horarioAberto: '05:00 - 22:00',
        possuiEstacionamento: false,
        endereco: 'Rua das Amoras, 126 - Jardim das flores',
        image: '/assets/images/parques/fonte-interativa.jpeg',
        distancia: 5,
        latitude: -23.0230,
        longitude: -43.4720,
      },
      {
        stars: '4.8',
        name: 'Parque exemplo 3',
        horarioAberto: '05:00 - 22:00',
        possuiEstacionamento: false,
        endereco: 'Rua das Amoras, 126 - Jardim das flores',
        image: '/assets/images/parques/quadra-futsal.jfif',
        distancia: 5,
        latitude: -23.0240,
        longitude: -43.4730,
      },
      {
        stars: '4.8',
        name: 'Parque exemplo 4',
        horarioAberto: '05:00 - 22:00',
        possuiEstacionamento: false,
        endereco: 'Rua das Amoras, 126 - Jardim das flores',
        image: '/assets/images/parques/palco.jfif',
        distancia: 5,
        latitude: -23.0250,
        longitude: -43.4740,
      },
      {
        stars: '4.8',
        name: 'Parque exemplo 5',
        horarioAberto: '05:00 - 22:00',
        possuiEstacionamento: false,
        endereco: 'Rua das Amoras, 126 - Jardim das flores',
        image: '/assets/images/parques/chafariz.jfif',
        distancia: 2,
        latitude: -23.0260,
        longitude: -43.4750,
      },
    ];

    return of(items);
  }
}
